import React from "react";
import BellIcon from "@fidget/common/assets/BellIcon.svg";
import styles from "./unsnoozedIcon.css";

export const UnsnoozedIcon = () => {
  return (
    <div className={styles.container}>
      <img src={BellIcon} />
    </div>
  );
};
